import pagesConfig from '../pages/config';

export default {
    type: 'clients',
    relations: pagesConfig.relations,
    composes: [
        'testimonials'
    ],
    components: {
        adminRecord: {
            name: 'AdministerClientsRecord',
            loader: () => import('./AdministerClientsRecord')
        },
        webRecord: {
            name: 'DisplayClientsRecord',
            loader: () => import('./DisplayClientsRecord')
        }
    },
}
